import { render, staticRenderFns } from "./EditOwnerCar.vue?vue&type=template&id=446acab3"
import script from "./EditOwnerCar.vue?vue&type=script&lang=js"
export * from "./EditOwnerCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports